export default {
  data () {
    return {
      select_tag: '',
      imgsrc: ''
    }
  },
  props: ['company_list', 'column-width', 'title', 'src-name'],
  methods: {
    // 跳转公司首页
    turnToCompanyHome (oa_id) {
      const {
        href
      } = this.$router.resolve({path:  '/entity/' + oa_id + '/home'})
      window.open(href, '_blank')
    },
    // 按钮跳转公司查询
    turnToCompanyQuery (select_tag, select_name = '') {
      const {
        href
      } = this.$router.resolve({ path:  '/driverlesscompany', query: {select_tag: select_tag, select_name: select_name} })
      window.open(href,'_blank')
    },
    getImgSrc () {
      return '../../../static/images/supply_driverless/' + this.srcName + '.png'
    }
  },
  created () {

  },
  mounted () {
    this.select_tag = this.title.replace(/\(.*?\)/g, "")
    // 总体盒子
    var column_flex = this.$refs.column_flex
    if(this.columnWidth) column_flex.style.width = this.columnWidth * 50 +"px"
    else column_flex.style.flex = '1'

  }
}



// WEBPACK FOOTER //
// ./src/supplychain/js/driverless_column_flex.js